import { render, staticRenderFns } from "./ListaSancao.vue?vue&type=template&id=a817dea0"
import script from "./ListaSancao.vue?vue&type=script&lang=js"
export * from "./ListaSancao.vue?vue&type=script&lang=js"
import style0 from "./ListaSancao.vue?vue&type=style&index=0&id=a817dea0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports